import { render, staticRenderFns } from "./MediaList.vue?vue&type=template&id=0c6ed9a7&scoped=true"
import script from "./MediaList.vue?vue&type=script&lang=js"
export * from "./MediaList.vue?vue&type=script&lang=js"
import style0 from "./MediaList.vue?vue&type=style&index=0&id=0c6ed9a7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c6ed9a7",
  null
  
)

export default component.exports